<template>
  <el-container
    :style="$route.name == 'eLearningIndex' ? '' : { height: wHeight + 'px' }"
  >
    <!-- <el-container> -->
    <el-header :height="wWidth > 976 ? '61px' : '43px'">
      <div style="background: #fff">
        <div class="container_nopadding">
          <div class="row-align-center justify-space-between header">
            <img
              class="dsal_logo"
              src="../assets/web/dsal_logo_black.png"
              @click="toHome"
            />
            <div class="nav" v-if="!isPublic">
              <ul class="nav_ul">
                <li
                  class="nav_li"
                  v-for="item in myRoutes"
                  :key="item.name"
                  :class="
                    item.meta.type == $route.meta.type ? 'nav_li_active' : ''
                  "
                  @click="nav(item)"
                >
                  {{
                    item.meta.code == "index"
                      ? $t("message.index")
                      : item.meta.code == "learning"
                      ? $t("message.course_learning")
                      : item.meta.code == "Record"
                      ? $t("message.practice_test")
                      : item.meta.code == "online_services"
                      ? $t("message.online_services")
                      : item.meta.code == "question"
                      ? $t("message.question")
                      : ""
                  }}
                </li>
              </ul>
            </div>
            <div class="row-align-center setting">
              <!-- PC版 -->
              <div class="user" v-if="!isPublic && !$store.state.isPreview">
                <el-dropdown @command="command">
                  <span class="el-dropdown-link" v-if="user">
                    <!-- {{user && user.euid}} -->
                    {{ user.nameCn || user.namePt }}
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <span @click="logout">{{ $t("message.logout") }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="lan">
                <LangSelect @command="command"></LangSelect>
              </div>
              <img
                v-if="!isPublic"
                src="../assets/phone/menu@3x.png"
                :class="`open_drawer${drawer ? ' open_drawer_transform' : ''}`"
                @click="drawer = drawer == true ? false : true"
              />
            </div>
          </div>
        </div>
      </div>
    </el-header>
    <div v-if="$store.state.isMobile && user.euid" class="username_xs">
      {{ user.nameCn || user.namePt }}
    </div>
    <el-main
      :style="
        $route.name == 'eLearningIndex' ? '' : { height: wHeight - 61 + 'px' }
      "
    >
      <!-- <div class="breadcrumb container">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            v-for="item in $route.meta.breadcrumb"
            :key="item.url"
            :to="{ path: item.url }"
          >{{item.name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>-->
      <router-view />

      <!-- drawer -->
      <div class="myDrawer">
        <el-drawer
          :visible.sync="drawer"
          :show-close="false"
          :append-to-body="false"
        >
          <div class="drawer-nav">
            <ul class="nav_ul">
              <li
                class="nav_li"
                v-for="item in myRoutes"
                :key="item.name"
                :class="
                  item.meta.type == $route.meta.type ? 'nav_li_active' : ''
                "
                @click="
                  nav(item);
                  drawer = false;
                "
              >
                <div class="row-align-center nav_li_xs">
                  <img
                    v-if="
                      item.meta.code == 'index' &&
                      item.meta.type != $route.meta.type
                    "
                    src="../assets/phone/Home.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'learning' &&
                      item.meta.type != $route.meta.type
                    "
                    src="../assets/phone/Course.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'Record' &&
                      item.meta.type != $route.meta.type
                    "
                    src="../assets/phone/Test.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'online_services' &&
                      item.meta.type != $route.meta.type
                    "
                    src="../assets/phone/Sign.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'question' &&
                      item.meta.type != $route.meta.type
                    "
                    src="../assets/phone/Search.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'index' &&
                      item.meta.type == $route.meta.type
                    "
                    src="../assets/phone/HomePress.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'learning' &&
                      item.meta.type == $route.meta.type
                    "
                    src="../assets/phone/CoursePress.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'Record' &&
                      item.meta.type == $route.meta.type
                    "
                    src="../assets/phone/TestPress.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'online_services' &&
                      item.meta.type == $route.meta.type
                    "
                    src="../assets/phone/SignPress.png"
                    style="width: 16px"
                  />
                  <img
                    v-if="
                      item.meta.code == 'question' &&
                      item.meta.type == $route.meta.type
                    "
                    src="../assets/phone/Search.png"
                    style="width: 16px"
                  />
                  <span>{{
                    item.meta.code == "index"
                      ? $t("message.index")
                      : item.meta.code == "learning"
                      ? $t("message.course_learning")
                      : item.meta.code == "Record"
                      ? $t("message.practice_test")
                      : item.meta.code == "online_services"
                      ? $t("message.online_services")
                      : item.meta.code == "question"
                      ? $t("message.question")
                      : ""
                  }}</span>
                </div>
                <div class="bottom_line"></div>
              </li>
            </ul>
            <div v-if="!$store.state.isPreview" class="drawer_foot">
              <el-button @click="logout">{{ $t("message.logout") }}</el-button>
            </div>
          </div>
        </el-drawer>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { Base64 } from "js-base64";
import router, { learnRoutes } from "../router";
import LangSelect from "../components/LangSelect";
import OAuthAPI from "../api/OAuthAPI";
import UserCourseAPI from "../api/UserCourseAPI";
import UserAssessmentsAPI from "../api/UserAssessmentsAPI";
import CourseAPI from "../api/CourseAPI";
export default {
  components: { LangSelect },
  data() {
    return {
      user: {},
      routes: learnRoutes,
      drawer: false,
      questionnaire: [],
      checkHasAssessment: false,
      course: {},
    };
  },
  // watch: {
  //   $route(to, from) {
  //     console.log("路由改变啦", to.query);
  //     this.$router.push({
  //       query: to.query
  //     });
  //   }
  // },x
  computed: {
    wWidth() {
      return this.$store.state.wWidth;
    },
    wHeight() {
      return this.$store.state.wHeight;
    },
    myRoutes() {
      const routes = this.routes.filter((item) => item.meta.nav == true);
      let myRoutes = this.$store.state.isPreview
        ? routes.filter((item) => item.meta.code != "Record")
        : routes.filter(item => item.meta.code != "Record" || this.checkHasAssessment);
      myRoutes.push({
        name: "online_services",
        meta: {
          code: "online_services",
          type: "nav_li_active",
          nav: true,
        },
      });
      if (this.questionnaire.length > 0 && !this.$store.state.auth) {
        myRoutes.push({
          name: "question",
          meta: {
            code: "question",
            type: "nav_li_active",
            nav: true,
          },
        });
      }
      if (this.$store.state.auth) {
        myRoutes = myRoutes.filter((ele) => ele.meta.code !== "learning");
      }
      return myRoutes;
    },
    isPublic() {
      const route = this.$route;
      const myQuery = this.myQuery;
      return route.meta.code == "question" || route.meta.code == "Success"
        ? myQuery && myQuery.type == "public"
          ? true
          : false
        : false;
    },
    myQuery() {
      let url = this.$route.query.code
        ? Base64.decode(this.$route.query.code)
        : null;
      if (url) {
        let hash;
        var myJson = {};
        var hashes = url.split("&");
        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split("=");
          myJson[hash[0]] = hash[1];
        }
        return myJson;
      } else {
        return null;
      }
    },
  },
  methods: {
    command() {
      this.get();
    },
    async nav(val) {
      if (val.meta.code == "online_services") {
        // 跳轉到網上報名頁面
        window.open(
          `https://www.dsal.gov.mo/${this.$i18n.locale.toLowerCase()}/standard/online_services.html`
        );
        return;
      }
      if (val.meta.code == "question") {
        // 跳轉問卷調查
        if (this.$store.state.isPreview) return false;
        if (this.course.progress <= 0.8) {
          this.$alert(this.$t("message.question_tips"), this.$t("message.tips"), {
            confirmButtonText: this.$t("message.confirm"),
            callback: action => {
              console.log(action);
            }
          });
          return;
        }
        const courseId = sessionStorage.getItem("courseId");
        const questionnaire = this.questionnaire;
        if (questionnaire.length > 0) {
          const code = Base64.encode(`id=${questionnaire[0].id}&type=user`);
          this.$router.push({
            path: "/question",
            query: {
              code: code,
            },
          });
        }
        return;
      }
      let myQuery = this.$store.state.isPreview
        ? this.$route.query.courseId
          ? { courseId: this.$route.query.courseId }
          : this.$route.query.courseVersionId
          ? {
              courseVersionId: this.$route.query.courseVersionId,
            }
          : {}
        : {};
      const auth = this.$store.state.auth;
      if(auth) myQuery.auth = auth;
      if (this.wWidth < 976 && val.path == "/learning")
        myQuery.activeName = "progress";
      if (val.path != this.$route.path) {
        this.$router.push({
          path: val.path,
          query: {
            ...myQuery,
          },
        });
      }
    },
    // 登出
    logout() {
      console.log("logout");
      localStorage.setItem("user", "");
      // window.location.href = "https://account.gov.mo/logout/";

      sessionStorage.setItem("courseId", "");
      window.location.href = "/elearning/servlet/api/v1/oauth/logout";
      // OAuthAPI.logout()
      //   .then(() => {
      //     sessionStorage.setItem("courseId", "");
      //     this.$router.push("/");
      //   })
      //   .catch(err => {
      //     this.$error(err);
      //   });
    },
    toHome() {
      if (this.isPublic || (this.$store.state.isPreview && !this.$store.state.auth)) return false;
      this.$router.push("/");
    },
    get() {},
    async jumpToLast() {
      const locale = this.$i18n.locale;
      const courseId = sessionStorage.getItem("courseId");
      const course = await CourseAPI.getOne(courseId, locale);
      this.course = course;
      // 跳轉判斷
      if (this.$store.state.isPreview) {
        return false;
      }
      if (sessionStorage.getItem("toLast") == "true") {
        // console.log(sessionStorage.getItem("toLast"));
        this.$store.commit("changeFirstLoad", false);
        sessionStorage.setItem("toLast", "false");
        // 如果需要填问卷，回到首页
        if (sessionStorage.getItem("logout")) {
          try {
            const progress = course.progress || 0;
            const questionnaires = await CourseAPI.listQuestionnaireByCourse(
              courseId,
              locale
            );
            const questionnaire =
              (questionnaires.length > 0 && questionnaires[0]) || {};
            if (progress >= 0.8 && !questionnaire.participated) {
              this.$router.push("/");
            }
          } catch (error) {
            this.$error(error);
          } finally {
            sessionStorage.removeItem("logout");
          }
        }
        if (courseId) {
          UserCourseAPI.findLastByUserAndCourse(courseId, locale)
            .then((res) => {
              if (res && res.id) {
                UserAssessmentsAPI.findByCourse(courseId, locale)
                  .then((data) => {
                    if (data) {
                      // this.$router.push("/index");
                    } else {
                      this.$store.commit("changeLast", res);
                      this.$router.push({
                        path: "/learning/course",
                      });
                    }
                  })
                  .catch((err) => {
                    this.$error(err);
                    console.log(err);
                  });
              } else {
                this.$router.push("/index");
              }
            })
            .catch((err) => {
              this.$error(err);
              console.log(err);
            });
        }
      }
    },
    // 獲取問卷數據
    getQuestionnaire() {
      const courseId = sessionStorage.getItem("courseId") || null;
      const locale = this.$i18n.locale;
      if (courseId) {
        CourseAPI.listQuestionnaireByCourse(courseId, locale)
          .then((res) => {
            this.loading = false;
            this.questionnaire = res;
          })
          .catch((err) => {
            this.loading = false;
            this.$error(err);
          });
      }
    },
    // 獲取模擬考試
    getHasAssessment() {
      if (!this.$store.state.isPreview) {
        const courseId = sessionStorage.getItem("courseId") || null;
        const locale = this.$i18n.locale;
        if (courseId) {
          CourseAPI.checkHasAssessment(courseId, locale)
            .then((res) => {
              this.checkHasAssessment = res;
            })
            .catch((err) => {
              this.$error(err);
            });
        }
      }
    },
  },
  async created() {
    // 判斷預覽
    if (!this.$store.state.isPreview) {
      // const code = this.$route.query.courseCode;
      let courseVersionId = this.$route.query.courseVersionId || null;
      let auth = this.$route.query.auth;
      // if (code) {
      //   const course = await CourseAPI.getCourseByCode(code, this.$i18n.locale);
      //   this.$router.push({
      //     path: 'index',
      //     query: {
      //       courseVersionId: course.id,
      //       auth: 1,
      //     }
      //   });
      //   return;
      //   // courseVersionId = course.id;
      //   // auth = "1";
      // }
      const courseId = this.$route.query.courseId || null;
      if (courseId || courseVersionId) {
        const preview = {
          isPreview: true,
          previewType: courseId ? "courseId" : "courseVersionId",
          PCourseId: courseId,
          PCourseVersionId: courseVersionId,
          auth: auth,
        };
        sessionStorage.setItem("courseId", courseId || courseVersionId);
        this.$store.commit("changePreview", preview);
      } else {
        const preview = {
          isPreview: false,
          previewType: null,
          PCourseId: null,
          PCourseVersionId: null,
          auth: auth,
        };
        this.$store.commit("changePreview", preview);
      }
      // 免登陸課程，調用記錄課程。
      if (auth) {
        CourseAPI.recordCourse(courseVersionId)
          .then(() => {})
          .catch((err) => this.$error(err));
      }
    }

    const type =
      !this.myQuery || !this.myQuery.type || this.myQuery.type != "public"
        ? true
        : false;
    if (!this.$store.state.isPreview && type) {
      OAuthAPI.getUserProfile()
        .then((res) => {
          // console.log("res");
          this.user = res;
          localStorage.setItem("user", JSON.stringify(res));
        })
        .catch((err) => {
          // if (process.env.NODE_ENV == "production") alert(JSON.stringify(err));
          this.$error(err);
        });
    }
    // const user = JSON.parse(localStorage.getItem("user")) || null;
    // this.user = user;

    if (!sessionStorage.getItem("toLast"))
      sessionStorage.setItem("toLast", "true");

    this.jumpToLast();
    this.get();
    this.getQuestionnaire();
    this.getHasAssessment();
  },
};
</script>

<style lang="scss" scoped>
.header {
}
.el-header {
  padding: 0;
}
.el-main {
  padding: 0;
  background: #f2f2f6;
}

/deep/.el-table th {
  padding: 16px 0;
  font-size: 18px;
  font-weight: 500;
  color: rgba(74, 74, 74, 1);
}

/* 分頁 */
/deep/.el-pager li.active,
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgba(22, 182, 149, 1) !important;
  color: #fff !important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: rgba(22, 182, 149, 1);
}

.breadcrumb {
  height: auto;
  margin-top: 14px;
  /deep/.el-breadcrumb {
    font-size: 16px;
    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
      color: rgba(22, 182, 149, 1);
      font-weight: bold;
    }
    .el-breadcrumb__inner.is-link:hover {
      color: rgba(22, 182, 149, 1);
    }
    .el-breadcrumb__separator {
      color: #333;
    }
    .el-breadcrumb__separator[class*="icon"] {
      font-weight: 500;
    }
  }
}

/deep/.el-radio {
  // line-height: inherit !important;
  // display: flex;
  // flex-direction: row;
  // align-items: center;
  .el-radio__inner {
    width: 19px;
    height: 19px;
    line-height: inherit;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #ffce2e;
    background: #ffce2e;
  }
  .el-radio__input.is-checked + .el-radio__label {
    background: #fcd8d1;
    color: #4a4a4a;
  }
  .el-radio__label {
    border-radius: 3px;
    margin-left: 24px;
    padding: 4px 10px;
  }
  .el-radio__inner:hover {
    border-color: #ffce2e;
  }
  .el-radio__input.is-focus .el-radio__inner {
    border-color: #ffce2e;
  }
}
/deep/.el-checkbox {
  // display: flex;
  // flex-direction: row;
  // align-items: center;
  .el-checkbox__inner {
    width: 19px;
    height: 19px;
    line-height: inherit;
    border-radius: 100px;
  }
  .el-checkbox__inner::after {
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 8px;
    left: 6px;
    top: 2px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #ffce2e;
    background: #ffce2e;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    background: #fcd8d1;
    color: #4a4a4a;
  }
  .el-checkbox__label {
    border-radius: 3px;
    margin-left: 24px;
    padding: 4px 10px;
  }
  .el-checkbox__inner:hover {
    border-color: #ffce2e;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #ffce2e;
  }
}
/deep/.el-textarea {
  .el-textarea__inner:focus {
    border-color: #ffce2e;
  }
}
/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(22, 182, 149, 1);
  color: #fff;
}
.username_xs {
  text-align: right;
  padding: 8px 15px;
  background: #5fc0d4;
  color: #fff;
  font-size: 24px;
}
</style>